// extracted by mini-css-extract-plugin
export default {"drawingButtonGroup":"map_drawingButtonGroup__kWzDg","user_marker_label":"map_user_marker_label__4c1tK","stop_marker_label":"map_stop_marker_label__DurxN"};